// Centralized SEO config for all pages
// Edit this file to update meta titles, descriptions, keywords, and image alt text for each page

const seoConfig = {
  home: {
    path: '/',
    title: 'Free Typing Test, Click Test & Games - WPM, CPM & CPS',
    description: 'Free online typing tests, click speed tests, and games. Check your WPM, CPM, and CPS, play Higher or Lower, Color Memory, Stop the Wheel, and track your highscore.',
    keywords: 'typing test, wpm test, cpm test, cps test, click speed test, typing games, higher or lower game, color memory game, stop the wheel game, population quiz, keyboard skills',
    imageAltText: {
      'cheetah.png': 'Cheetah representing a very fast typing speed rank.',
      'wolf.png': 'Wolf representing an advanced typist rank.',
      'rabbit.png': 'Rabbit representing an intermediate typist rank.',
      'turtle.png': 'Turtle representing a beginner typist rank.',
      'snail.png': 'Snail representing a slow typing speed rank.',
      'falcon.png': 'Peregrine Falcon representing an expert typist rank, the highest achievement.',
    },
  },
  about: {
    path: '/about-typing-clicking-tests',
    title: 'About Our Tests | What is WPM, CPM & CPS Explained',
    description: 'Learn what WPM, CPM, and CPS mean and how our tests accurately measure your typing and clicking speed. Get tips to improve your scores and accuracy.',
    keywords: 'about typing test, what is wpm, what is cpm, what is cps, improve typing speed, typing accuracy, click speed explained',
    imageAltText: {},
  },
  privacy: {
    path: '/privacy',
    title: 'Privacy Policy - Typing & Clicking Tests',
    description: 'Read our privacy policy to understand how we handle your data and protect your privacy during your typing and clicking test experience.',
    keywords: 'privacy policy, typing test, data protection, user data',
    imageAltText: {},
  },
  results: {
    title: 'Your Typing Test Results - Analyze Your WPM & Accuracy',
    description: 'View your detailed typing test results, including WPM, CPM, accuracy, and your official animal rank. Share your score or try again to beat it!',
    keywords: 'typing test results, wpm score, cpm score, typing accuracy, animal rank, keyboard speed',
    imageAltText: {},
  },
  '15s-cpm-typing-test': {
    path: '/15s-cpm-typing-test',
    title: '15 Second Typing Test (CPM & WPM) - Free Online Speed Game',
    description: 'Play a free 15-second typing test online. Measure your WPM and CPM in a quick keyboard speed challenge with instant results and accuracy tracking.',
    keywords: '15 second typing test, quick typing test, cpm test, wpm check, speed check, keyboard test, free typing game',
    imageAltText: {},
  },
  '30s-cpm-typing-test': {
    path: '/30s-cpm-typing-test',
    title: '30 Second Typing Test (CPM & WPM) - Free Burst Challenge',
    description: 'Take a free 30-second typing test and see how fast and accurate you are. A short online keyboard game that tracks WPM, CPM, and mistakes.',
    keywords: '30 second typing test, short typing test, cpm challenge, wpm test, typing challenge, free typing game',
    imageAltText: {},
  },
  '1min-cpm-typing-test': {
    path: '/60s-cpm-typing-test',
    title: '1 Minute Typing Test (WPM) - Free Standard Speed Game',
    description: 'Try the classic 1-minute typing test online for free. Measure your Words Per Minute (WPM), CPM, and accuracy in the most popular keyboard speed challenge.',
    keywords: '1 minute typing test, one minute typing, wpm test, cpm typing test, standard typing test, free typing game',
    imageAltText: {},
  },
  '3min-cpm-typing-test': {
    path: '/3min-cpm-typing-test',
    title: '3 Minute Typing Test - Free Endurance Speed Game',
    description: 'Free 3-minute typing test online. Challenge your focus, speed, and accuracy over a longer session and track your WPM and CPM progress.',
    keywords: '3 minute typing test, extended typing test, typing accuracy test, wpm, cpm, typing practice, free typing game',
    imageAltText: {},
  },
  '5min-cpm-typing-test': {
    path: '/5min-cpm-typing-test',
    title: '5 Minute Typing Test - Free Ultimate Endurance Game',
    description: 'Can you keep your speed for 5 minutes? Take this free endurance typing test online and improve your long-form WPM, CPM, and accuracy.',
    keywords: '5 minute typing test, endurance typing, long typing test, typing practice paragraphs, wpm, cpm, free typing game',
    imageAltText: {},
  },
  '1s-cps-click-test': {
    path: '/1s-cps-click-test',
    title: '1 Second Click Test - Free CPS Speed Game',
    description: 'Free 1-second click speed test online. Measure your raw Clicks Per Second (CPS) instantly in a fast reflex clicking game.',
    keywords: '1 second click test, cps test, click speed, reflex test, fast clicker, mouse test, free click game',
    imageAltText: {},
  },
  '5s-cps-click-test': {
    path: '/5s-cps-click-test',
    title: '5 Second Click Speed Test - Free CPS Game',
    description: 'Free 5-second click speed test online. Check your CPS, total clicks, and mouse speed in a popular short clicking challenge.',
    keywords: '5 second click test, click speed test, cps test, clicks per second, mouse skills, gaming mouse test, free click game',
    imageAltText: {},
  },
  '15s-cps-click-test': {
    path: '/15s-cps-click-test',
    title: '15 Second Click Speed Test - Free CPS Endurance Game',
    description: 'How many clicks can you score in 15 seconds? Free online CPS test with total clicks, speed tracking, and instant results.',
    keywords: '15 second click test, click speed, cps challenge, endurance clicking, mouse speed, free click game',
    imageAltText: {},
  },
  '30s-cps-click-test': {
    path: '/30s-cps-click-test',
    title: '30 Second Click Speed Test - Free Mouse Challenge',
    description: 'Free 30-second click speed test online. Push your CPS and clicking stamina in a longer mouse speed game with live scoring.',
    keywords: '30 second click test, click speed test, cps, ultimate challenge, mouse clicking game, free click game',
    imageAltText: {},
  },
  '60s-cps-click-test': {
    path: '/60s-cps-click-test',
    title: '60 Second Click Test - Free 1 Minute CPS Marathon',
    description: 'Free 1-minute click speed test online. See how many clicks you can score and track your CPS in a marathon mouse clicking game.',
    keywords: '60 second click test, 1 minute click test, cps stamina test, click marathon, clicker test, free click game',
    imageAltText: {},
  },
  'higher-or-lower': {
    path: '/higher-or-lower',
    title: 'Higher or Lower Country Quiz - Population vs Territory Size',
    description: 'Play Higher or Lower online for free. Compare country populations and territory sizes — including mixed rounds — beat your highscore, and test your number intuition.',
    keywords: 'higher or lower, population game, territory size game, country area game, geography game, number comparison, free online game, trivia game',
    imageAltText: {},
  },
  'color-memory': {
    path: '/color-memory',
    title: 'Color Memory Game - Guess the Color & Score Your Accuracy',
    description: 'Free Color Memory game online. Memorize a color for 5 seconds, recreate it with sliders, and see how close your guess is with an instant accuracy score.',
    keywords: 'color memory game, guess the color, color matching game, memory game, color quiz, free online game, color accuracy test',
    imageAltText: {},
  },
  'stop-the-wheel': {
    path: '/stop-the-wheel',
    title: 'Stop the Wheel Game - Free Reaction & Timing Test',
    description: 'Free Stop the Wheel game online. Play 30 levels: stop the wheel on the target as it gets smaller and faster. Test your reaction timing with a score out of 100.',
    keywords: 'stop the wheel, reaction test, timing game, reflex game, wheel game, accuracy test, free online game',
    imageAltText: {},
  },
  'click-test-results': {
    title: 'Your Click Test Results - See Your CPS Score & Rank',
    description: 'View your official click test results! See your Clicks Per Second (CPS), total clicks, and get your unique rank and a fun roast. Try again to get faster!',
    keywords: 'click test results, cps score, click speed, mouse click rank, cps rank, gaming cps',
    imageAltText: {},
  },
};

export default seoConfig;
